angular
  .module('refundPointList')
  .component('refundPointList', {
    template: require('./refund-point-list.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', '$cookies', 'AuthService', 'envService',
      function controller($rootScope, $scope, $resource, $route, $location, $window, $translate, $cookies, AuthService, envService) {
        $rootScope.mainmenu = 'orders';
        $rootScope.menu = 'refundPointList';
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.showOrderView = $rootScope.gShowOrderView;
        $scope.doLogout = $rootScope.gLogout;
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }
        $scope.loginMember = AuthService.loginMember();
        this.paging = (page) => {
          $resource(`${APIURL}/admin/refund/points`).get({ page: page - 1 }, (data) => {
            this.orders = data.orders;
            this.total_count = data.totalCount;
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        this.markRefunded = (request) => {
          if (!confirm($translate.instant('환불 완료 처리 하시겠습니까?'))) {
            return;
          }
          $resource(`${APIURL}/admin/refund/requests/${request.ID}`).save({}, () => {
            request.REFUNDED = 'Y';
          }, (err) => {
            console.error(err);
            if (err.data && err.data.msg) {
              alert(err.data.msg);
            } else {
              alert($translate.instant('알수 없는 에러 입니다.'));
            }
          });
        };
        this.paging(1);
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/refund-point-list/refund-point-list.component.js